export default __webpack_public_path__ + "static/media/battery.1983aa6e.svg";